<template>
  <div
    class="option_selection"
    v-if="details.selectableAttributes!= null && (details.selectableAttributes.SIZE || details.selectableAttributes.COLOR)"
  >
    <div v-if="details.selectableAttributes.COLOR " class="prod_color">
      <h6 class="prdt_sub_hdng" >{{$t('color')}}</h6>
      <ul class="color_list">
        <!-- <li
          v-for="(clr,index) in details.selectableAttributes.COLOR"
          :class="{'prod_act ': colors == index,' ': colors != index}"
          :key="index"        
          :style="[colors == index ? colors != index ? {'background' : 'none'} : {'background' :  getColor(clr.itemAttributeValue)} : {'backgroundColor' : '#fff'} ]"         
        >
          <input
            type="radio"
            name="radio2"
            :id="'clr'+index"
            :value="index"
            class="cstm_radio"
            v-model="colors"
            @click="selectColor(index,clr.itemAttributeValue)"
          />
          <label class="cstm_label" :for="'clr'+index" :style="{backgroundColor : getColor(clr.itemAttributeValue), border: '5px solid' + '' + getColor(clr.itemAttributeValue)}">
          </label>
        </li> -->
        <li
          v-bind:class="{'prod_act ': colors == index,' ': colors != index}"
          v-for="(clr,index) in details.selectableAttributes.COLOR"
          :key="index"
        >
          <input
            type="radio"
            name="radio2"
            :id="'clr'+index"
            :value="index"
            class="cstm_radio"
            v-model="colors"
            @click="selectColor(index,clr.itemAttributeValue)"
          />
          <label class="cstm_label" :for="'clr'+index">
            <span class="colr_txt">{{clr.itemAttributeValue}}</span>
          </label>
        </li>
      </ul>
    </div>
      <div v-if="details.selectableAttributes.SIZE" class="prod_color">
        <h6 class="prdt_sub_hdng">{{$t('size')}}</h6>
        <ul>
          <li
            v-bind:class="{'prod_act': prodSize == index,'':selectedItemAttributeIds.includes(s.itemId),'deactive': !selectedItemAttributeIds.includes(s.itemId)}"
            v-for="(s,index) in details.selectableAttributes.SIZE"
            :key="index"
          >
            <input
              type="radio"
              name="radio3"
              :id="'s'+index"
              :value="index"
              class="cstm_radio"
              v-model="prodSize"
              @click="selectSize(index,s.itemAttributeValue)"
            />
            <label class="cstm_label" :for="'s'+index">{{s.itemAttributeValue}}</label>
          </li>
        </ul>
      </div>
    <div class="loader" v-if="loading">
      <img src="../../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import AllColorArray from "../../../utils/AllColorArray";
import { bus } from "../../../main";
export default {
  name: "Color",
  props: {
    dataColor: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      details: {},
      colors: 0,
      loading: false,
      prodSize: 0,
      selectedItemAttributeIds: [],
      colorType: "",
      sizeID: "",
      styleColorArray: {},
      styleObject: AllColorArray,
      colorName: ''
    };
  },
  watch: {
    dataColor() {
      this.details = this.dataColor;
      this.checkColorArray();
      this.checkSizeArray();
    }
  },

  methods: {
    getColor(val){
      const index=Object.keys(this.styleObject).indexOf(val.toLowerCase())
      return Object.values(this.styleObject)[index]
    },
    getBorderColor(val, indexValue){
      const index=Object.keys(this.styleObject).indexOf(val.toLowerCase())
      if(this.colors == indexValue){
       return Object.values(this.styleObject)[index]
      }else if(this.colors != indexValue){
        return 'white';
      }
      
    },
    checkColorArray() {
      if (
        this.dataColor.selectableAttributes != null &&
        this.dataColor.selectableAttributes.COLOR &&
        this.dataColor.selectableAttributes.COLOR.length > 0
      ) {
        this.details.selectableAttributes.COLOR.forEach((tem, index) => {
          if (this.$route.params.saleReferenceID == tem.itemId) {
            this.colorType = tem.itemAttributeValue;
            this.sizeID = tem.itemId;
            this.$emit("ProductColor", tem.itemAttributeValue);
            this.selectedItemAttributeIds.push(tem.itemId);
            this.getSizeAttibuteByColor(this.colorType);
            this.colors = index;
          }else if(this.dataColor.saleReferenceID == tem.itemId){
             this.colorType = tem.itemAttributeValue;
            this.sizeID = tem.itemId;
            this.$emit("ProductColor", tem.itemAttributeValue);
            this.selectedItemAttributeIds.push(tem.itemId);
            this.getSizeAttibuteByColor(this.colorType);
            this.colors = index;
          }
        });
      }
    },
    checkSizeArray() {
      if (
        this.dataColor.selectableAttributes != null &&
        this.dataColor.selectableAttributes.SIZE &&
        this.dataColor.selectableAttributes.SIZE.length > 0
      ) {
        this.dataColor.allSelectableAttributes.SIZE.forEach((tem, index) => {
          if (this.$route.params.saleReferenceID == tem.itemId) {
            var attributeValue = tem.itemAttributeValue;
            this.$emit("ProductSize", attributeValue);
            this.$emit("saleReferenceID", tem.itemId);
          } else if(this.dataColor.saleReferenceID == tem.itemId){
             var attributeValue = tem.itemAttributeValue;
            this.$emit("ProductSize", attributeValue);
            this.$emit("saleReferenceID", tem.itemId);
          }
          this.selectedItemAttributeIds.push(tem.itemId);
        });

        this.dataColor.selectableAttributes.SIZE.forEach((tem, index) => {
          if (this.$route.params.saleReferenceID == tem.itemId) {
            var attributeValue = tem.itemAttributeValue;
            this.$emit("ProductSize", attributeValue);
            this.$emit("saleReferenceID", tem.itemId);
            this.prodSize = index;
          }else if(this.dataColor.saleReferenceID == tem.itemId){
             var attributeValue = tem.itemAttributeValue;
            this.$emit("ProductSize", attributeValue);
            this.$emit("saleReferenceID", tem.itemId);
          }
        });
      }
    },
    selectColor(index, Color) {
      this.loading = true
      this.$emit("ProductColor", Color);
      this.loading = true;
      this.colors = index;
      this.getSizeAttibuteByColor(
        this.details.selectableAttributes.COLOR[index].itemAttributeValue
      );
      let saleRefId = this.details.selectableAttributes.COLOR[index].itemId;
      let obj = {
        saleReferenceID: saleRefId
      };

      this.$store
        .dispatch({
          type: "getProductDetail",
          payload: obj
        })
        .then(data => {
          this.loading = false
          this.details.finalPaidAmount = data.data.finalPaidAmount;
          let obj = {
            stock: data.data.inStock,
            finalPaidAmount: data.data.finalPaidAmount,
            mrp: data.data.mrp
          };
          this.$emit("Stock", obj);
          this.loading = false;
          this.$store.commit("PRODUCTDETAIL", data.data);
        })
        .catch(err => {
          let obj = {
            status: "Failure",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        });
      if (
        this.details.selectableAttributes != null &&
        this.details.selectableAttributes.SIZE &&
        this.details.selectableAttributes.SIZE[this.prodSize]
      ) {
        this.dataColor.allSelectableAttributes.SIZE.forEach((tem, index) => {
          if (saleRefId == tem.itemId) {
            var attributeValue = tem.itemAttributeValue;
            this.$emit("ProductSize", attributeValue);
            this.$emit("saleReferenceID", tem.itemId);
          }
        });
        
        if (
          this.dataColor.selectableAttributes != null &&
          this.dataColor.selectableAttributes.SIZE &&
          this.dataColor.selectableAttributes.SIZE.length > 0
        ) {
          this.dataColor.selectableAttributes.SIZE.forEach((tem, index) => {
            if (saleRefId == tem.itemId) {
              var attributeValue = tem.itemAttributeValue;
              this.$emit("ProductSize", attributeValue);
              this.$emit("saleReferenceID", tem.itemId);
              this.prodSize = index;
            }
          });
        }
      }
    },
    selectSize(index, size) {
      this.loading = true
      this.prodSize = index;
      if (
        this.details.selectableAttributes &&
        this.details.selectableAttributes.SIZE &&
        this.details.selectableAttributes.SIZE[index]
      ) {
        this.$emit(
          "saleReferenceID",
          this.details.selectableAttributes.SIZE[index].itemId
        );
        this.$route.params.saleReferenceID = this.details.selectableAttributes.SIZE[
          index
        ].itemId;

        let obj = {
          saleReferenceID: this.details.selectableAttributes.SIZE[index].itemId
        };

        this.$store
          .dispatch({
            type: "getProductDetail",
            payload: obj
          })
          .then(data => {
            this.loading = false
            this.details.finalPaidAmount = data.data.finalPaidAmount;
            let obj = {
              stock: data.data.inStock,
              finalPaidAmount: data.data.finalPaidAmount,
              mrp: data.data.mrp
            };
            this.$emit("Stock", obj);
            this.loading = false;
          })
          .catch(err => {
            let obj = {
              status: "Failure",
              timeoutMs: "5000"
            };
            bus.$emit("apiStatus", obj);
          });

        this.$emit("ProductSize", size);
      }
    },
    getSizeAttibuteByColor(attributeValue) {
      this.selectedItemAttributeIds = [];
      var uniqueSize = [];
      var uniqueAttributeName = [];
      if (
        this.details.selectableAttributes != null &&
        this.details.selectableAttributes.SIZE &&
        this.details.selectableAttributes.SIZE[this.prodSize]
      ) {
        this.$emit(
          "saleReferenceID",
          this.details.selectableAttributes.SIZE[this.prodSize].itemId
        );
        this.$route.params.saleReferenceID = this.details.selectableAttributes.SIZE[
          this.prodSize
        ].itemId;
      }

      if (attributeValue != null) {
        this.details.allSelectableAttributes.COLOR.forEach(tem => {
          if (attributeValue == tem.itemAttributeValue) {
            this.selectedItemAttributeIds.push(tem.itemId);
          }
        });
      }
      //Get size for selected colur
      if (
        this.details.allSelectableAttributes &&
        this.details.allSelectableAttributes.SIZE
      ) {
        this.details.allSelectableAttributes.SIZE.forEach(tem => {
          if (
            this.selectedItemAttributeIds.indexOf(tem.itemId) >= 0 &&
            uniqueSize.indexOf(tem.itemId) == -1
          ) {
            uniqueSize.unshift(tem);
            uniqueAttributeName.unshift(tem.itemAttributeValue);
          }
          //note:: in case single color make selectable all size
          if (
            (this.details.allSelectableAttributes &&
              this.details.allSelectableAttributes.COLOR &&
              this.details.allSelectableAttributes.COLOR.length == 1) ||
            this.details.allSelectableAttributes.COLOR == null
          ) {
            this.selectedItemAttributeIds.push(tem.itemId);
          }
        });

        //note :remove duplicates from SIZE arrray
        this.details.selectableAttributes.SIZE.forEach(tem => {
          if (uniqueAttributeName.indexOf(tem.itemAttributeValue) == -1) {
            uniqueSize.push(tem);
          }
        });
        this.details.selectableAttributes.SIZE = [];
        this.details.selectableAttributes.SIZE = uniqueSize;
      }
    }
  },
  mounted() {
    this.details = this.dataColor;
    //Get items id for selected attributes name
   
    this.checkColorArray();
    this.checkSizeArray();
  }
};
</script>